import type { ReactElement } from 'react';
import type { ILocaleConfig } from '@/types/localeTypes';
import { LocaleOption } from './LocaleOption';
import { useTranslations } from '@/hooks/useTranslations';
import styles from './LocalePicker.module.scss';

interface ILocalePickerProps {
  locales: ILocaleConfig[];
  onSelect: (localeCode: string) => void;
}

/**
 * Locale Picker Component
 * Displays grid of available locales with selection handling
 */
export function LocalePicker({ locales, onSelect }: ILocalePickerProps): ReactElement {
  const { t } = useTranslations();
  
  return (
    <div className={styles.localePicker}>
      <p className='font-size-h4 font-weight-semibold'>{t("localePicker.title")}</p>
      
      <div className={styles.localeGrid}>
        {locales.length > 0 ? (
          locales.map((locale) => (
            <LocaleOption
              key={locale.code}
              locale={locale}
              onSelect={onSelect}
            />
          ))
        ) : (
          <p className='font-size-h5'>{t("localePicker.noLocalesAvailable")}</p>
        )}
      </div>
    </div>
  );
}
